import Paragrafo2 from '../immaginiDino/ChiSiamoImg/paragrafo2.jpg';
import Paragrafo1 from '../immaginiDino/ChiSiamoImg/paragrafo1.jpg';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import fotoVinoCard from '../immaginiDino/ChiSiamoImg/fotoVinoCard.jpeg';
import fotoOliveCard from '../immaginiDino/ChiSiamoImg/fotoOliveCard.jpeg';
import React, {useEffect, useState} from "react";
import HomeCarousel from "../components/homeCarousel";
import {Carousel} from "react-responsive-carousel";

function ChiSiamo() {
    useEffect(() => {
        document.title = "Chi Siamo - Cantina Testacalla";
    }, []);

    return (
        <>
            <div className="bg-[#D9D9D9] h-[0.6375rem]"></div>

            {/* Titolo "Chi Siamo" */}
            {/*
            <div className="flex justify-center mt-4 md:mt-6">
                <h1 className="ChiSiamoTitoli bordo mt-0 text-center text-2xl md:text-5xl">Chi Siamo</h1>
            </div>*/}

            {/* Paragrafo Descrittivo */}
            {/*
            <div className="flex justify-center items-center w-full px-4 md:px-0">
                <div
                    className="flex flex-col md:flex-row justify-center items-center text-justify mb-8 md:mb-[4.125rem]">
                    <p className="border-l-4 border-l-[#691219] max-w-lg md:max-w-[33.1875rem] px-4 md:pl-6 md:pr-4 h-full">
                        La cantina Testacalla produce sia vini che olio extra vergine di oliva, questi prodotti sono
                        frutto di una tradizione famigliare antica, con metodi tramandati di generazione in generazione,
                        come spiega il titolare della cantina, Bernardino Bisogni, da tutti conosciuto nella zona come
                        DINO.
                        "La nostra famiglia ha sempre prodotto vino, io lo facevo con mio padre sin da piccolo, è lui
                        che
                        mi ha trasmesso questa passione. Un giorno però, quando avevo 17 anni, purtroppo è venuto a
                        mancare e questo ha rappresentato per me un duro colpo, tanto da spegnere il fuoco e la voglia
                        che
                        avevo per questo mestiere.
                        Poi, nel 2000, l’incontro con mio suocero, proveniente dalla Russia, è stato decisivo per la
                        storia di questa cantina. La voglia di mostrargli quello che sapevo fare bene, di cui andavo fiero
                      e soprattutto il suo entusiasmo e apprezzamento nei miei confronti, mi ridiedero la spinta per
                      ricominciare a produrre, e così feci, sempre di più, anno dopo anno.
                  </p>
              </div>
          </div>
          */}

          <div className="flex flex-col items-center w-full h-full bg-[#691219] mb-4">
              <div
                  className="flex flex-col md:flex-row lg:flex-row xl:flex-row 2xl:flex-row items-center p-8 gap-8 md:gap-32">
                  <div className="w-full md:w-[375px] h-[500px] md:h-[500px] relative overflow-hidden" style={{touchAction: 'pan-y'}}>
                      <HomeCarousel/>
                  </div>

                  <div className="flex flex-col items-center md:items-start text-white">
                      <p className="border-t-[0.2rem] mb-4 text-2xl md:text-3xl text-center md:text-left">
                          CANTINA TESTACALLA
                      </p>

                      <div className="max-w-[520px] text-xl font-light text-center md:text-left">
                          <p>
                              La Cantina Testacalla è un'affermata realtà vinicola situata nel cuore dell'Umbria, specializzata nella produzione di vini e olio extra vergine di oliva di alta qualità. Fondata da Bernardino Bisogni, noto come Dino, la cantina si distingue per i suoi prodotti caserecci, frutto di una tradizione familiare e della passione per l'agricoltura. I vini, tra cui il prestigioso Sagrantino, e l'olio extravergine sono realizzati con metodi artigianali e rispettosi dell'ambiente. Ogni prodotto racconta una storia di cura e dedizione, offrendo un'esperienza unica che celebra il meglio della cultura enologica e olivicola umbra.
                          </p>
                      </div>
                  </div>
              </div>
          </div>

            {/* Sezione "La nostra storia" */}
            <div className="flex justify-center mt-8 md:mt-8">
                <h1 className="ChiSiamoTitoli bordo mt-0 text-center text-4xl md:text-5xl">La nostra storia</h1>
            </div>

            <div
                className="flex flex-col md:flex-row items-center justify-center w-full mt-4 md:mt-6 px-4 md:px-0 space-y-4 md:space-y-0 md:space-x-8 pb-8 mb-12">

                <div className="flex justify-center items-center border-l-4 border-l-[#C1A823] h-full px-4 md:px-6">
                    <p className="max-w-lg md:max-w-[32.55rem] h-full text-left">
                        La cantina Testacalla produce sia vini che olio extra vergine di oliva, questi prodotti sono
                        frutto di una tradizione famigliare antica, con metodi tramandati di generazione in generazione,
                        come spiega il titolare della cantina, Bernardino Bisogni, da tutti conosciuto nella zona come
                        DINO.
                        <br/><br/>
                        "La nostra famiglia ha sempre prodotto vino, io lo facevo con mio padre sin da piccolo, è lui che
                        mi ha trasmesso questa passione. Un giorno però, quando avevo 17 anni, purtroppo è venuto a
                        mancare e questo ha rappresentato per me un duro colpo, tanto da spegnere il fuoco e la voglia che
                        avevo per questo mestiere.
                        Poi, nel 2000, l’incontro con mio suocero, proveniente dalla Russia, è stato decisivo per la storia di questa cantina. La voglia di mostrargli quello che sapevo fare bene, di cui andavo fiero e soprattutto il suo entusiasmo e apprezzamento nei miei confronti, mi ridiedero la spinta per ricominciare a produrre, e così feci, sempre di più, anno dopo anno."

                    </p>
                </div>

                <img src={Paragrafo1}
                     className="w-full md:w-[15.7125rem] h-auto object-cover md:object-contain rounded-md"/>
            </div>

          <div className="flex justify-center items-center w-full px-4 md:px-0 relative bg-image h-[800px]">
              <div className="glass-overlay flex-row">
                  <ProductsSection/>
              </div>
          </div>

            {/*
          <div
              className="flex flex-col md:flex-row items-center justify-center w-full mt-4 md:mt-6 px-4 md:px-0 space-y-4 md:space-y-0 md:space-x-8">
              <img src={Paragrafo1}
                   className="w-full md:w-[15.7125rem] h-auto object-cover md:object-contain rounded-md"/>

              <div className="flex justify-center items-center border-r-4 border-r-[#C1A823] h-full px-4 md:px-6">
                  <p className="max-w-lg md:max-w-[32.55rem] h-full">
                      La Cantina Testacalla è un'azienda vinicola e olearia situata in una regione privilegiata per la
                      coltivazione di
                      viti e olive. Produce vini di alta qualità utilizzando uve selezionate e metodi di produzione
                      tradizionali
                      combinati con tecnologie moderne. Inoltre, l'azienda possiede una linea di produzione di olio
                      d'oliva di alta
                      qualità, ottenuto da olive fresche e raccolte a mano. La Cantina Testacalla è orgogliosa della sua
                      tradizione e
                      della sua passione per la produzione di vini e oli eccellenti.
                  </p>
              </div>
          </div> */}


          {/* Sezione "Territorio" */}
          <div className="flex justify-center mt-16 md:mt-16">
              <h1 className="ChiSiamoTitoli bordo mt-0 text-center text-4xl md:text-5xl">Territorio</h1>
          </div>

          <div
              className="flex flex-col md:flex-row items-center justify-center w-full mt-4 md:mt-6 px-4 md:px-0 space-y-4 md:space-y-0 md:space-x-8 mb-16">
              <div className="flex justify-center items-center border-l-4 border-l-[#C15C23] h-full px-4 md:px-6">
                  <p className="max-w-lg md:max-w-[32.55rem] h-full text-left">
                      Il vigneto TESTACALLA è un apprezzamento di terra di 10.000 mq e si trova in Località Casale di
                      Montefalco, nel cuore verde dell'Umbria.
                      E' composto per la metà dal vitigno autoctono Sagrantino di Montefalco e per metà dal dai vitigni
                      di qualità delle uve MERLOT, CABERNET, SANGIOVESE(50%) e SAGRANTINO, dalla combinazione dei quali
                      si ricava l'amatissimo vino ROSSO DI MONTEFALCO. L'attitudine nei confronti della produzione è
                      quella di seguire la stagionalità, gli unici responsabili della qualità del vino infatti sono il
                      sole, la pioggia e le temperature. Non vengono utlizzati prodotti chimici, per questo il vino può
                      non risultare sempre uguale poiché dipende dalla qualità dell'uva di ogni specifico anno; il suo
                      profumo, il suo gusto e le sue caratteristiche non saranno mai gli stessi. Ciò nonostante anche
                      nelle annate meno favorevoli Bernardino Bisogni cerca di portare in tavola sempre prodotti di alta
                      qualità.
                      <br/><br/>"La QUALITA' del vino, come spiega Dino, inizia nei vigneti che, a partire dalla
                      primavera, necessitano cura, potatura e pulizia. E' un lavoro di pazienza che non può limitarsi
                      solo al momento della raccolta, ma necessita fatica e costanza durante tutto l'anno, per la buona
                      riuscita del vino"
                  </p>
              </div>

              <img src={Paragrafo2}
                   className="w-full md:w-[15.7125rem] h-auto object-cover md:object-contain rounded-md"/>
          </div>
      </>
  );
}
export default ChiSiamo;

function CardVino(){
    return (
        <div className="bg-rose-200 p-6 pb-8 max-w-xs mx-auto text-center rounded-md shadow-lg">
            {/* Titolo */}
            <p className="text-2xl font-semibold text-red-900 mb-2 tracking-widest text-center pl-1">VINO</p>

            {/* Divider con punto centrale */}
            <div className="flex items-center justify-center mb-4">
                <div className="border-t border-red-900 w-1/4"></div>
                <div className="w-[18px] h-3 bg-red-900 rounded-[50%] mx-4"></div>
                <div className="border-t border-red-900 w-1/4"></div>
            </div>

            {/* Immagine del vino */}
            <div className="mb-4">
                <img
                    src={fotoVinoCard}
                    alt="Vino"
                    className="w-full h-auto rounded-md"
                />
            </div>

            {/* Testo di descrizione */}
            <p className="text-sm text-gray-800 leading-relaxed">
                La Cantina Testacalla offre il Sagrantino Secco, un vino rosso intenso, e il Sagrantino Passito, dolce e aromatico. Completa l'offerta il Rosso di Montefalco, corposo e adatto a carni.
            </p>
        </div>
    )
}

function CardOlio(){
    return (
        <div className="bg-[#E2FFBD] p-6 pb-8 max-w-xs mx-auto text-center rounded-md shadow-lg">
            {/* Titolo */}
            <p className="text-2xl font-semibold text-[#0D4925] mb-2 tracking-widest text-center pl-1">OLIO</p>

            {/* Divider con punto centrale */}
            <div className="flex items-center justify-center mb-4">
                <div className="border-t border-[#0D4925] w-1/4"></div>
                <div className="w-[18px] h-3 bg-[#0D4925] rounded-[50%] mx-4"></div>
                <div className="border-t border-[#0D4925] w-1/4"></div>
            </div>

            {/* Immagine del vino */}
            <div className="mb-4">
                <img
                    src={fotoOliveCard}
                    alt="Vino"
                    className="w-full h-auto rounded-md"
                />
            </div>

            {/* Testo di descrizione */}
            <p className="text-sm text-gray-800 leading-relaxed">
                L'Olio Extra Vergine di Oliva Testacalla è biologico, raccolto a mano e spremuto fresco per garantire qualità. Disponibile in bottiglie e taniche.
            </p>
        </div>
    )
}

const ProductsSection = () => {
    // Stato per monitorare la larghezza dello schermo
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Effetto per aggiornare lo stato quando la finestra viene ridimensionata
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="flex justify-center items-center w-full px-4 md:px-0 relative bg-image h-[900px]">
            <div className="glass-overlay flex-col">
                <h1 className="text-black text-5xl mt-8 mb-2">Prodotti</h1>
                <div className="dispCards flex-row gap-8 lg:gap-16">
                    {/* Layout per schermi sotto a md */}
                    {isMobile ? (
                        <div className="w-full flex-row items-center justify-center" style={{touchAction: 'pan-y'}}>
                            <Carousel
                                infiniteLoop={false}
                                showThumbs={true}
                                showIndicators={true}
                                showStatus={false}
                                interval={3000}
                                transitionTime={500}
                                stopOnHover={false}
                                showArrows={true}
                                swipeScrollTolerance={5}
                                preventMovementUntilSwipeScrollTolerance={true}
                            >
                                <div className="px-2">
                                    <CardVino />
                                </div>
                                <div className="px-2">
                                    <CardOlio />
                                </div>
                            </Carousel>
                        </div>
                    ) : (
                        // Layout per schermi sopra a md
                        <>
                            <div className="px-2">
                                <CardVino />
                            </div>
                            <div className="px-2">
                                <CardOlio />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};